import React from 'react';
import { Row, Column } from '@upgrade/react-components';
import { Section } from '../common/styles';
import Fluid from '../Fluid';
import { StyledPoweredByDescription, StyledPoweredByText, StyledPoweredByImage } from './styles';

const PoweredByUpgrade = ({ description, poweredByText, image }) => (
  <Section data-color="backgroundPage">
    <Fluid>
      <Row xsHorizontalAlign="center">
        <Column xs={12}>
          <StyledPoweredByDescription>{description}</StyledPoweredByDescription>
          <StyledPoweredByText>{poweredByText}</StyledPoweredByText>
          <StyledPoweredByImage src={image} alt="Upgrade" />
        </Column>
      </Row>
    </Fluid>
  </Section>
);

export default PoweredByUpgrade;
